import { isServer } from 'utils';

export function isTouchDevice() {
  return isServer() ? false : (
    ('ontouchstart' in window)
    || (navigator.maxTouchPoints > 0)
    || (navigator.msMaxTouchPoints > 0)
  );
}
